export const judicialCentres = [
	{ code: '01', re: /^..01/, title: 'Calgary' },
	{ code: '02', re: /^..02/, title: 'Drumheller' },
	{ code: '03', re: /^..03/, title: 'Edmonton' },
	{ code: '04', re: /^..04/, title: 'Grande Prairie' },
	{ code: '06', re: /^..06/, title: 'Lethbridge' },
	{ code: '08', re: /^..08/, title: 'Medicine Hat' },
	{ code: '09', re: /^..09/, title: 'Peace River' },
	{ code: '10', re: /^..10/, title: 'Red Deer' },
	{ code: '12', re: /^..12/, title: 'Wetaskiwin' },
	{ code: '13', re: /^..13/, title: 'Fort McMurray' },
	{ code: '14', re: /^..14/, title: 'St. Paul' },
];
